import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import { ServiceTabs } from "./ServiceTabs";
import { ServicePanel } from "./ServicePanel";
import { SERVICE_CATEGORIES } from "../data/services";

export const Services = () => {
  const [activeId, setActiveId] = useState(SERVICE_CATEGORIES[0].id);
  const index = SERVICE_CATEGORIES.findIndex((c) => c.id === activeId);

  return (
    <section
      id="services"
      data-testid="services-section"
      className="grain relative scroll-mt-20 bg-[#383D33] py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          light
          eyebrow="Our Services"
          title="The Service Menu"
          subtitle="Choose a category to explore our services: hair, skin, nails and wellness. Then reserve your chair in seconds."
        />

        <Reveal className="mt-16">
          <div className="grid gap-8 lg:grid-cols-12 lg:gap-12">
            <div className="min-w-0 lg:col-span-3">
              <div className="lg:sticky lg:top-28">
                <ServiceTabs activeId={activeId} onSelect={setActiveId} />
              </div>
            </div>
            <div className="min-w-0 lg:col-span-9">
              <AnimatePresence mode="wait">
                <ServicePanel key={activeId} category={SERVICE_CATEGORIES[index]} index={index} />
              </AnimatePresence>
            </div>
          </div>
        </Reveal>

        <Reveal>
          <p
            data-testid="services-menu-footnote"
            className="mt-12 text-center font-body text-xs italic tracking-wider text-[#F2EFE6]/50"
          >
            All chemical services include a shampoo &amp; blow-dry &middot; Appointments are
            recommended, walk-ins are welcome
          </p>
        </Reveal>

        <Reveal>
          <div className="mt-8 flex flex-col items-center justify-between gap-6 rounded-3xl border border-[rgba(201,162,75,0.35)] bg-[#454538] px-8 py-10 text-center sm:px-12 lg:flex-row lg:text-left">
            <div>
              <p className="font-brand text-2xl text-[#F2EFE6] sm:text-3xl">Not sure where to begin?</p>
              <p className="mt-2 font-body text-sm leading-relaxed text-[#F2EFE6]/70">
                Tell us what you are dreaming of, and our stylists will recommend the perfect
                service for you.
              </p>
            </div>
            <a
              href="#book"
              data-testid="services-book-now-button"
              className="btn-shimmer shrink-0 rounded-full bg-[#C9A24B] px-8 py-4 font-body text-xs font-semibold uppercase tracking-[0.2em] text-[#383D33] transition-colors duration-300 hover:bg-[#D4AF37]"
            >
              Book an Appointment
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
